module.exports = __webpack_public_path__ + "img/gas_x_extra_strength_chewables.a4ccddd5.jpg";